import * as yup from "yup";

export type ValidationErrorsV2 = Record<string, string>;

export async function validateV2<T>(schema: yup.SchemaOf<any> | yup.AnySchema, value: T) {
  try {
    await schema.validate(value, { abortEarly: false });
    return {} as ValidationErrorsV2;
  } catch (error) {
    const errors = {} as ValidationErrorsV2;
    if (error instanceof yup.ValidationError) {
      error.inner.forEach((fieldError) => {
        if (fieldError.path && !errors[fieldError.path]) {
          errors[fieldError.path] = fieldError.message;
        }
      });
      if (error.path && !errors[error.path]) errors[error.path] = error.message;
    }
    return errors;
  }
}

export function hasErrors(errors: ValidationErrorsV2) {
  return Object.keys(errors).length > 0;
}
